import React from 'react'
import { Collection } from '@/types/codegen-contentful'
import { GetProjectTilesQuery } from '@/types/codegen-federation'
import { ReactFCC } from '@/types/react'

interface AboutContextType {
  impact: Collection
  tiles: GetProjectTilesQuery
  numberOfGuildMembers?: string
  lastUpdated?: string
  guildMembershipNumbers: Collection
}

interface AboutContextProps extends AboutContextType {
  children: React.ReactNode
}

const AboutContext = React.createContext<AboutContextType>({
  impact: {} as Collection,
  tiles: {},
  numberOfGuildMembers: '650,000',
  lastUpdated: 'Jan 22, 2025',
  guildMembershipNumbers: {} as Collection,
})

export const AboutContextProvider: ReactFCC<AboutContextProps> = ({
  children,
  impact,
  tiles,
  numberOfGuildMembers,
  lastUpdated,
  guildMembershipNumbers,
}) => {
  const value = { impact, tiles, numberOfGuildMembers, lastUpdated, guildMembershipNumbers }

  return <AboutContext.Provider value={value}>{children}</AboutContext.Provider>
}

export function useAboutContext() {
  return React.useContext(AboutContext)
}
